import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b6856c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "small text-gray-500 text-center px-4 py-2"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "flex w-full flex-col" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_ConversationItem = _resolveComponent("ConversationItem")!
  const _component_fr_skeleton = _resolveComponent("fr-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_field, {
        placeholder: "Buscar",
        name: "search"
      })
    ]),
    _createElementVNode("div", null, [
      _createVNode(_Transition, {
        name: "list-content",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          (!_ctx.loading && _ctx.conversations.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_TransitionGroup, {
                  name: "conversations",
                  tag: "div",
                  appear: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conversations, (conv) => {
                      return (_openBlock(), _createBlock(_component_ConversationItem, {
                        key: `conv-${conv.id}`,
                        conversation: conv
                      }, null, 8, ["conversation"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]))
            : (!_ctx.loading && _ctx.conversations.length == 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString('No hay conversaciónes que listar')))
              : (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (t) => {
                      return _createElementVNode("div", {
                        key: `skeleton-${t}`,
                        class: "px-4 py-2 flex justify-start"
                      }, [
                        _createVNode(_component_fr_skeleton, {
                          circle: "",
                          width: "40px",
                          class: "mr-4 flex-shrink-0"
                        }),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_fr_skeleton, {
                            height: "1.25rem",
                            class: "mb-1"
                          }),
                          _createVNode(_component_fr_skeleton, { height: "1.25rem" })
                        ])
                      ])
                    }), 64))
                  ]))
                : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ])
  ]))
}